<template>
    <el-dialog title="角色菜单授权" :visible="visible" :show="show" width="80%"   @close="close" :close-on-click-modal="false" custom-class="module-dialog">
        <el-button v-show="this.tableData.length>0" type="primary" class="btn-success" @click="onSubmit" style="text-align:right">提交</el-button>
        <el-container style="height: 500px; border: 1px solid #eee">
            <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
                <el-tree
                        :data="data"
                        show-checkbox
                        node-key="menuId"
                        :default-checked-keys="checkedKeys"
                        @check-change="handleCheckChange"
                        :default-expand-all="true"
                        ref="menuTree"
                        :props="defaultProps">
                </el-tree>

            </el-aside>

            <el-container>
                <el-main>
                    <el-table :data="tableData" v-loading="loading">
                        <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
                        <el-table-column prop="resName" label="菜单名称" width="200"></el-table-column>
                        <el-table-column prop="alias" label="菜单别名" width="200"></el-table-column>
                        <el-table-column prop="defaultUrl" label="访问地址" width="200"></el-table-column>
                        <el-table-column prop="sn" label="排序" width="100"></el-table-column>
                        <el-table-column prop="btnList" label="菜单权限控制">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.userBtnListArr" style="width:80%" multiple v-if="currentMenuBtnList[scope.$index].length>0">
                                    <el-option v-for="(item,i) in currentMenuBtnList[scope.$index]" :label="item.indexName" :key="i" :value="item.codeIndex+''"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-main>
            </el-container>
        </el-container>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'RoleSetMenu',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                    this.initMenuList();
                    this.initMenuBtnList();
                }
            },
            rowData(){

            },
        },
        data(){
            return{
                loading:false,
                updateBtn:true,
                url:base.get().url,
                visible:false,
                tableData:[],
                checkedKeys:[],
                props: {
                    resName: 'name',
                    children: 'zones'
                },
                menuList:[],
                currentMenuBtnList:[],
                data: [{
                    menuId: 1,
                    label: '一级 1',
                    children: [{
                        menuId: 4,
                        resName: '二级 1-1',
                    }]
                }],
                defaultProps: {
                    children: 'children',
                    resName: 'label'
                },
                menuBtnList:[],
            }
        },
        methods:{
            close(){
                this.updateBtn = true;
                this.tableData = [];
                this.checkedKeys = [];
                this.$emit("listenToChildEventRle",false);
            },
            initMenuList(){
                this.$http({
                    url: "menu/getTreeMenuList",
                    method: "get",
                }).then(({data}) => {
                    if(data && data.code === 0){
                        //this.rootMenuList = data.rootMenuList;
                        let arr = [];
                        for (let i = 0;i<data.rootMenuList.length;i++){
                            let node = data.rootMenuList[i];
                            let children = [];
                            for (let j = 0;j<node.menuList.length;j++){
                                let childNode = node.menuList[j];
                                let obj = {resName:childNode.resName,label:childNode.resName,menuId:childNode.id,alias:childNode.alias,parentId:childNode.parentId,
                                    btnList:childNode.btnList,icons:childNode.icons,defaultUrl:childNode.defaultUrl,sn:childNode.sn,btnList:childNode.btnList,roleId:this.rowData.roleId};
                                children.push(obj);
                            }
                            let obj = {label:node.resName,resName:node.resName,menuId:node.id,alias:node.alias,parentId:node.parentId,btnList:node.btnList,icons:node.icons,
                                children:children,defaultUrl:node.defaultUrl,sn:node.sn,roleId:this.rowData.roleId};
                            arr.push(obj);
                        }
                        this.data = arr;
                    }
                });
            },
            handleCheckChange(data, checked) {
                if (checked){
                    if (!this.checkedKeys.includes(data.menuId)){
                        this.tableData.push(data);
                    }
                    let btnListArr = [];
                    for (let i = 0;i<this.menuBtnList.length;i++){
                        if (data.btnList!='' && data.btnList.indexOf(this.menuBtnList[i].codeIndex)!=-1){
                            btnListArr.push(this.menuBtnList[i]);
                        }
                    }
                    this.tableData.map((obj,i)=>{
                        if(obj.resName==data.resName){
                            this.currentMenuBtnList.splice(i,1,btnListArr);
                        }
                    })
                }else{
                    let index = 0;
                    let flag = false;
                    this.tableData.map((node,i)=>{
                        if(data.menuId==node.menuId){
                            flag = true;
                            index = i;
                        }
                    });
                    if(flag){
                        this.tableData.splice(index,1);
                    }
                }
                this.$forceUpdate();
            },
            initMenuBtnList(){
                let params = {
                    page: 1,
                    limit: 30,
                    sort: 'id',
                }
                params['dicCode'] = "menu_types"//编码名字
                params['dicName'] = "按钮类型",//汉字名字
                this.$http({
                    url: "dictionary/page",
                    method: "get",
                    params: params
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        this.menuBtnList = data.data.list;
                        if(this.rowData.roleId!=undefined){
                            this.initRoleSelectMenuList(this.rowData.roleId);
                        }
                    }
                });
            },
            onSubmit(){
                this.tableData.map(item=>{
                    if(item.userBtnListArr.length>0){
                        item.btnList = item.userBtnListArr.join(",");
                    }else{
                        item.btnList = '';
                    }
                });
                this.$http({
                    url: `roleMenu/save`,
                    method: "post",
                    data: this.tableData
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                            duration: 1500,
                            onClose: () => {
                                this.close();
                            }
                        });
                    } else {
                        this.$message.error(data.msg);
                    }
                });

            },
            initRoleSelectMenuList(roleId){
                this.$http({
                    url: "roleMenu/list",
                    method: "get",
                    params:{roleId:roleId}
                }).then(({data}) => {
                    if(data && data.code === 0){
                        this.loading = true;
                        let arr = [];
                        data.data.map(item=>{
                            item.userBtnListArr = item.btnList.split(",");
                            arr.push(item.menuId);
                            this.currentMenuBtnList.push([]);
                        });
                        this.tableData = data.data;
                        this.checkedKeys = arr;
                        this.loading = false;
                    }
                });
            }

        }
    }
</script>
<style lang="scss">
    .el-form-item__label{
        font-weight:bold
    }
</style>
<style>
    .el-header {
        background-color: var(--publicMainColor);
        color: #fff;
        line-height: 60px;
    }

    .el-aside {
        color: #303133;
    }
</style>